import moment from "moment/moment";


const TIME_FORMAT_12H = 'hh:mm A';
const TIME_FORMAT_24H = 'HH:mm';

/**
 * @typedef {Object} EventTimeInput
 * @property {'2-digit'} hour
 * @property {'2-digit'} minute
 * @property {boolean} hour12
 */

/**
 * @typedef {Object} CalendarInput
 * @property {number} firstDay
 * @property {EventTimeInput} eventTimeInput
 */

/**
 * @typedef {Object} LocaleTimeCalendarInput
 * @property {string} timeFormat
 * @property {CalendarInput} calendarInput
 */

/**
 * @typedef {Object.<string, LocaleTimeCalendarInput>} LocaleTimeCalendarMap
 */
const localeTimeCalendarInputMap = {
    "en-au": {
        timeFormat: TIME_FORMAT_12H,
        calendarInput:{ firstDay: 1, eventTimeInput:{ hour: '2-digit', minute: '2-digit', hour12: true} }
    },
    "en-gb": {
        timeFormat: TIME_FORMAT_24H,
        calendarInput:{ firstDay: 1, eventTimeInput:{ hour: '2-digit', minute: '2-digit', hour12: false} }
    },
    "en-nz": {
        timeFormat: TIME_FORMAT_12H,
        calendarInput:{ firstDay: 1, eventTimeInput:{ hour: '2-digit', minute: '2-digit', hour12: true} }
    },
    "en-sg": {
        timeFormat: TIME_FORMAT_24H,
        calendarInput:{ firstDay: 1, eventTimeInput:{ hour: '2-digit', minute: '2-digit', hour12: false} }
    },
    "en": {
        timeFormat: TIME_FORMAT_12H,
        calendarInput:{ firstDay: 0, eventTimeInput:{ hour: '2-digit', minute: '2-digit', hour12: true} }
    },
}

/**
 * @param {string} locale
 * @return {CalendarInput}
 */
export function getCalendarInput(locale) {

    const _locale = locale || "en";
    const { calendarInput }= localeTimeCalendarInputMap[_locale];

    return calendarInput;
}

/**
 * @param {string} locale
 * @return {string}
 */
export function getTimeFormat(locale) {

    const _locale = locale || "en";
    const { timeFormat }= localeTimeCalendarInputMap[_locale];

    return timeFormat;
}


/**
 * @param {string} inputTime
 * @param {string} inputFormat
 * @param {string} locale
 */
export function getMomentLocaleTimeFormat(inputTime, inputFormat, locale) {

    const _locale = locale || "en";
    const {timeFormat}= localeTimeCalendarInputMap[_locale];

    return moment(inputTime, inputFormat).format(timeFormat);
}

